// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__38gI4","actions":"GroupTable_actions__3PS0J","deleteModalFooter":"GroupTable_deleteModalFooter__2nKQE"};